export default __webpack_public_path__ + "static/media/job_4.1bfaec02.png";